import React from 'react';
export function IntroSection() {
  return <div className="bg-white border-b border-gray-200" data-id="element-4067">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-4" data-id="element-4068">
        <p className="text-gray-700 text-base md:text-lg leading-relaxed" data-id="element-4069">
          Browse our inventory of high-quality used CNC and EDM machines ready
          for immediate purchase. Peak Machine Sales sources reliable pre-owned
          equipment including wire EDM, sinker EDM, hole-drilling EDM, and
          precision machining systems from leading brands such as
          AgieCharmilles, Seibu America, EDM Network, Spinner, Breton, and Bodor
          Laser.
        </p>
        <p className="text-gray-700 text-base md:text-lg leading-relaxed" data-id="element-4070">
          Buying used machinery is a smart way to expand your shop's
          capabilities while reducing capital costs. Our inventory is constantly
          updated through a strong network of manufacturers and dealers across
          North America. If you don't see the machine you need, contact us—our
          team can help locate the right equipment for your operation.
        </p>
      </div>
    </div>;
}